module.exports = __webpack_public_path__ + "media/images/top/pap/common/img_point02-e0d5d21929a798a30359401a6f8c958f.png";